<script>
import Vue                                  from 'vue';
import { PolarArea }                        from 'vue-chartjs'
import { SDLUtil, MenuUtil, StringUtil }    from '@/utils';

export default {
    extends: PolarArea,
    props: {
        chart: {
            type: Object,
            default: null
        },
        settings: {} 
    },
    data() {
        return {
            data: {},
            chartType: '',
            chartData: { },
            options: {
                responsive: true,
                maintainAspectRatio: false,
                legend: { position: 'bottom' },
            }
        }
    },
    created() {
        Vue.$log.info('※ PolarAreaChart.vue created data =>', this.chart);
        if(this.chart !== null) {
            this.chartType = this.chart.chartType;
            this.data = this.chart.chartData;
        };

        let cLabels = [], cData = [], cBackColor = ['#364fc7', '#60c0dc', '#ff8c58', '#5fb760'];
        for(let i = 0; i < this.data.length; i++) {
            let data = this.data[i];
            cLabels.push(data.CONTENTS);
            cData.push(data.CNT);
            if (this.data.length > cBackColor.length) {
                cBackColor.push(StringUtil.getRandomColor());
            }
        }

        Object.assign(this.chartData, {
            labels : cLabels,
            datasets: [{
                data: cData,
                backgroundColor: cBackColor
            }]
        });

        Object.assign(this.options, {
            title: {
                display: true,
                position: 'bottom',
                text: this.settings.TITLE
            }
        });
    },
    mounted () {
        this.renderChart(this.chartData, this.options);
    }
};
</script>


// WEBPACK FOOTER //
// src/skpComponents/view/basis/dashboard/charts/PolarAreaChart.vue